<template>

</template>
<script>
export default {
  name: 'BaseAlert'
}
</script>
